import { useQuery } from '@tanstack/react-query';

import { modelVersionKeys } from '@/shared/lib/query/queryKeys';

import { fetchModelVersions } from '@/entities/model-version/api';
import type { ModelVersionSearchParams } from '@/entities/model-version/domain';

const extractModelNameFromFilter = (filter?: string): string | undefined => {
  if (!filter) return undefined;
  const match = filter.match(/name\s*=\s*['"]([^'"]+)['"]/i);
  return match ? match[1] : undefined;
};

export const useModelVersions = (params: ModelVersionSearchParams, enabled = true) => {
  const modelName = params.name || extractModelNameFromFilter(params.filter);

  return useQuery({
    queryKey: modelName
      ? modelVersionKeys.modelVersions(modelName, params)
      : [...modelVersionKeys.modelVersionsPrefix(), params],
    queryFn: () => fetchModelVersions(params),
    enabled,
    staleTime: 5 * 60 * 1000,
  });
};
